import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private readonly _snackBar: MatSnackBar) {}

  // Muestra Snackbar en pantalla, recibe un mensaje a mostrar y un string para el boton de action
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openWithVariableDuration(
    message: string,
    action: string,
    duration: number
  ): void {
    this._snackBar.open(message, action, {
      duration: duration,
    });
  }
}
